import { useState, ReactNode } from 'react';
import { IconButton } from '@treezor/design-system';
import { clsx } from 'clsx';

interface IAccordionProps {
  parentNode: ReactNode;
  children: ReactNode;
  className?: string;
}

export function Accordion({ parentNode, children, className }: IAccordionProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div className="flex flex-col">
      <div className={clsx('flex items-center justify-start gap-3', className)}>
        {parentNode}
        <IconButton
          icon="expand_more"
          size="s"
          className={clsx('transition-transform', isOpen && 'rotate-180')}
          onClick={() => setIsOpen((open) => !open)}
        />
      </div>
      <div className={clsx('grid transition-all duration-200', isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]')}>
        <div className="overflow-hidden">{children}</div>
      </div>
    </div>
  );
}
